import { render, staticRenderFns } from "./WorkersCalendarInfo.vue?vue&type=template&id=35b6e176"
import script from "./WorkersCalendarInfo.vue?vue&type=script&lang=ts"
export * from "./WorkersCalendarInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports